
import React, { useState, useEffect } from "react";

export const SharedSourceViewer = () => {
  const [fileList, setFileList] = useState([]);
  const [selectedPath, setSelectedPath] = useState("");
  const [fileContent, setFileContent] = useState("");
  const [statusMessage, setStatusMessage] = useState("");

  useEffect(() => {
    fetch("/api/list-sandbox-files")
      .then((res) => res.json())
      .then((data) => {
        if (data.files) {
          setFileList(data.files);
        }
      });
  }, []);

  const loadFile = (path) => {
    fetch(`/api/read-sandbox-file?path=${encodeURIComponent(path)}`)
      .then((res) => res.json())
      .then((data) => {
        setSelectedPath(path);
        setFileContent(data.content || "");
        setStatusMessage("");
      });
  };

  const saveFile = () => {
    fetch("/api/sandbox-write", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: selectedPath, content: fileContent }),
    })
      .then((res) => res.json())
      .then((data) => {
        setStatusMessage(data.success ? "? File saved" : "? Save failed");
      });
  };

  return (
    <div style={{ padding: "1rem" }}>
      <h2>Shared Source Viewer</h2>
      <div style={{ display: "flex", gap: "1rem" }}>
        <div style={{ width: "30%" }}>
          <h4>Files</h4>
          <ul style={{ maxHeight: "500px", overflowY: "scroll", border: "1px solid #ccc", padding: "0.5rem" }}>
            {fileList.map((file, index) => (
              <li key={index}>
                <button onClick={() => loadFile(file)} style={{ width: "100%", textAlign: "left" }}>
                  {file}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div style={{ flex: 1 }}>
          <h4>Editor: {selectedPath || "No file selected"}</h4>
          <textarea
            style={{ width: "100%", height: "400px", fontFamily: "monospace" }}
            value={fileContent}
            onChange={(e) => setFileContent(e.target.value)}
          />
          <br />
          <button onClick={saveFile} style={{ marginTop: "0.5rem" }}>
            Save
          </button>
          <div>{statusMessage}</div>
        </div>
      </div>
    </div>
  );
};

export default SharedSourceViewer;
